import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import OdooPaymentTermsSelector from "components/shared/OdooPaymentTermsSelector";
import useOdooCustomers from "hooks/useOdooCustomers";
import CustomerAddressView from "./CustomerAddressView";

const OdooCustomerInfoView = ({ customer }) => {
  const { loading, error, odooCustomers } = useOdooCustomers({
    instance: "AB",
    useType: "CUSTOMER_DETAIL",
    ids: [customer.odooPartnerId],
  });

  if (loading) return <InlineSpinner size={18} />;
  if (error) return <Errors error={error} />;

  console.log("odooCustomers", odooCustomers);

  if (odooCustomers.length === 0) return <div>No Odoo customer found.</div>;

  const odooCustomer = odooCustomers[0];

  return (
    <div>
      <div className="-mx-2 whitespace-nowrap">
        <table>
          <tbody>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>Name</label>:
              </td>
              <td className="w-full">{odooCustomer.name}</td>
            </tr>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>VAT</label>:
              </td>
              <td className="w-full">{odooCustomer.vat}</td>
            </tr>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>Email</label>:
              </td>
              <td className="w-full">{odooCustomer.email}</td>
            </tr>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>Country</label>:
              </td>
              <td className="w-full">{odooCustomer.country_code}</td>
            </tr>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>Price List</label>:
              </td>
              <td className="w-full">
                <div className="whitespace-normal">
                  <div>
                    {odooCustomer.property_product_pricelist.display_name}
                  </div>
                  <div className="whitespace-normal opacity-70 mt-1">
                    Make sure you choose the odoo price list with a correct
                    currency. This is required in Odoo when creating orders. It
                    does not matter if the price list has products or not. You
                    will manage the sales price in wis price list after.
                  </div>
                  {(!customer.priceList ||
                    !odooCustomer.property_product_pricelist.display_name.includes(
                      customer.priceList.currency,
                    )) && (
                    <div className="mt-1 text-red-600">
                      ⚠️ <b>Check Currency!</b> The price list you selected does
                      not match the customer's currency. Please ensure the price
                      list is set up correctly in Odoo and wis.
                    </div>
                  )}
                </div>
              </td>
            </tr>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>Payment Terms</label>:
              </td>
              <td className="w-full">
                <OdooPaymentTermsSelector
                  company={customer.system}
                  value={odooCustomer.property_payment_term_id?.id || null}
                  disabled
                />
              </td>
            </tr>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>Receivable Account</label>:
              </td>
              <td className="w-full">
                {odooCustomer.property_account_receivable_id.display_name}
                {odooCustomer.property_account_receivable_id.display_name.includes(
                  "DO NOT USE",
                ) && (
                  <span className="text-red-500 pl-3 font-semibold">
                    ⚠️ DO NOT USE THIS ACCOUNT, please update the customer
                    accounting settings in Odoo.
                  </span>
                )}
              </td>
            </tr>
            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>Payable Account</label>:
              </td>
              <td className="w-full">
                {odooCustomer.property_account_payable_id.display_name}
                {odooCustomer.property_account_payable_id.display_name.includes(
                  "DO NOT USE",
                ) && (
                  <span className="text-red-500 pl-3 font-semibold">
                    ⚠️ DO NOT USE THIS ACCOUNT, please update the customer
                    accounting settings in Odoo.
                  </span>
                )}
              </td>
            </tr>

            <tr className="border-y border-gray-100 dark:border-gray-700">
              <td>
                <label>Tags</label>:
              </td>
              <td className="w-full">
                {odooCustomer.category_id.length > 0 ? (
                  <div className="flex flex-wrap gap-2">
                    {odooCustomer.category_id.map((tag) => (
                      <div
                        key={tag.id}
                        className="px-3 py-1 bg-gray-200 dark:bg-gray-700 rounded-full text-[11px]"
                      >
                        {tag.display_name}
                      </div>
                    ))}
                  </div>
                ) : (
                  <span className="opacity-70">-</span>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <CustomerAddressView odooCustomer={odooCustomer} />
    </div>
  );
};

export default OdooCustomerInfoView;
